import { RefObject, useEffect, MouseEvent } from 'react'

import { useOnRefTargetClick } from './useOnRefTargetClick'

/**
 * Calls a callback function on clicking outside the referenced element
 */
export const useOnClickOutside = (
  ref: RefObject<HTMLElement | null>,
  callback?: () => void,
  condition?: (e: MouseEvent) => boolean,
  forEvent: 'mousedown' | 'click' = 'mousedown',
) => {
  const handleClick = useOnRefTargetClick(ref, callback, condition)
  return useEffect(() => {
    document.addEventListener(forEvent, handleClick as any)
    return () => {
      document.removeEventListener(forEvent, handleClick as any)
    }
  }, [handleClick, forEvent])
}
